<deprecated-labeled-field [label]="label" [help]="help" [required]="required">
  <div #container class="container">
    <input
      #inputElement
      [class.invalid]="invalid"
      [disabled]="disabled"
      [class.error]="error"
      [required]="required"
      [readonly]="readonly"
      [value]="text"
      [ngClass]="classes"
      (input)="changeText($event.target.value)"
      [placeholder]="'mm/dd/yyyy'"
      tabindex="0"
      pattern="[0-9]{1,2}\/[0-9]{1,2}\/[0-9]{4}"
      maxlength="10"
      (keypress)="keypress($event)"
    />
    <button
      [disabled]="disabled"
      class="calendar-btn"
      type="button"
      (click)="open.next(true)"
    >
      <riv-icon [name]="'Calendar'"></riv-icon>
    </button>
  </div>
</deprecated-labeled-field>
<ng-container *ngIf="open | async">
  <deprecated-callout
    *deprecated-callout
    class="callout"
    [anchor]="container"
    fallbackDirection="cw"
    [allowedPositions]="topAndBottomPositions"
    (close)="open.next(false)"
  >
    <deprecated-date-picker
      [date]="value"
      [min]="min"
      [max]="max"
      [disabled]="readonly"
      [clearable]="clearable"
      (changeDate)="changeValue($event); open.next(false)"
      (clearDate)="clearDate.emit()"
    ></deprecated-date-picker>
  </deprecated-callout>
</ng-container>
